import React from "react";
import styled from "styled-components";

//
import FaqCard from "../../../components/faq-card/FaqCard";
import FAQLIST from "../../../assets/data/faq-list";

export default function FaqList() {
  return (
    <StyledFaqList>
      <div className="container">
        <div className="faq-list__wrap">
          <ul>
            {FAQLIST.map((i) => (
              <li key={i.id}>
                <FaqCard title={i.title} text={i.text} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </StyledFaqList>
  );
}

const StyledFaqList = styled.section`
  padding: 140px 0;

  .faq-list {
    &__wrap {
      ul {
        display: flex;
        flex-direction: column;
        gap: 40px;
      }
    }
  }
`;
